export default __webpack_public_path__ + "static/media/Squares.bd4c2445.svg";